import React, {useState, useEffect} from 'react'
import EnteringAnimation from './enteringAnimation';
import FirstBlock from './firstBlock'
import Navigation from './navigation'
import SecondBlock from './secondBlock'
import ThirdBlock from './thirdBlock'
import FourthBlock from './fourthBlock';
import FifthBlock from './fifthBlock';
import PersonalInfo from './personalInfo';
import {Routes, Route, useParams, useNavigate} from 'react-router-dom'
import ky from 'ky'

function App() {
  return (
  <>
    <Routes>
      <Route path='/' element={<Main/>} />
      <Route path='/:id' element={<Main/>}/>
      <Route path='/:id/about' element={<About/>}/>
    </Routes>
  </>
    
  );
}

function About() {
  return (
    <>
      <Navigation/>
      <PersonalInfo/>
    </>
  )
}

function Main() {
  const navigate = useNavigate()
  const {id} = useParams()
  const [profileError, setProfileError] = useState('')

  useEffect(() => {
    const controller = new AbortController()
    setProfileError('')
    if (!id || !(/^\d+$/.test(id))) {
      navigate('/420061875', {replace: true})
    } else {
      ky.get(`/api/doesExist/${id}`, {signal: controller.signal}).json()
        .then(exists => {
          if (!controller.signal.aborted && !exists) navigate('/420061875', {replace: true})
        })
        .catch(error => {
          if (!controller.signal.aborted) setProfileError('Не удалось проверить страницу. Попробуйте обновить её позже.')
        })
    }
    return () => controller.abort()
  }, [id, navigate])
  return (
  <>
    <div className='w-screen'>
      {profileError && <p role="alert" className="text-center p-4">{profileError}</p>}
      <EnteringAnimation/>
      <Navigation/>
      <FirstBlock/>
      <SecondBlock/>
      <ThirdBlock/>
      <FourthBlock/>
      <FifthBlock/>
    </div>
  </>
  )
}

export default App;
